/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type model_rule_change_model_rule_full = {
  change_model_rule_id: string;
  action: model_rule_change_model_rule_full.action;
};
export namespace model_rule_change_model_rule_full {
  export enum action {
    ENABLE = 'Enable',
    DISABLE = 'Disable',
  }
}
